import React, { useState, useMemo } from 'react';

// ── Interfacce ────────────────────────────────────────────────────────────
interface Colonna {
  key: string;
  label: string;
  mono?: boolean;
}

interface ModaleCercaRecordProps {
  titolo: string;
  colonne: Colonna[];
  dati: any[];
  campoRicerca: string[];
  onSeleziona: (record: any) => void;
  onChiudi: () => void;
}

// ── Componente ────────────────────────────────────────────────────────────
export default function ModaleCercaRecord({
  titolo,
  colonne,
  dati,
  campoRicerca,
  onSeleziona,
  onChiudi,
}: ModaleCercaRecordProps) {
  const [filtro, setFiltro] = useState('');

  // Filtra i dati in base al testo di ricerca
  const datiFiltrati = useMemo(() => {
    if (!filtro.trim()) return dati;

    const filtroLower = filtro.toLowerCase();
    return dati.filter((record) => {
      return campoRicerca.some((campo) => {
        const valore = record[campo];
        if (valore == null) return false;
        return String(valore).toLowerCase().includes(filtroLower);
      });
    });
  }, [dati, filtro, campoRicerca]);

  return (
    <div className="bop-modale-cerca__overlay" onClick={(e) => e.stopPropagation()}>
      <div className="bop-modale-cerca__content" onClick={(e) => e.stopPropagation()}>
        <h3 className="bop-modale-cerca__header">{titolo}</h3>

        <input
          type="text"
          placeholder="Cerca..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          className="bop-modale-cerca__search"
          autoFocus
        />

        {datiFiltrati.length === 0 ? (
          <div className="bop-modale-cerca__empty">
            {filtro ? 'Nessun risultato trovato' : 'Nessun dato disponibile'}
          </div>
        ) : (
          <div className="bop-modale-cerca__table-scroll">
            <table className="bop-modale-cerca__table">
              <thead>
                <tr>
                  {colonne.map((col) => (
                    <th key={col.key}>
                      {col.label}
                    </th>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {datiFiltrati.map((record, idx) => (
                  <tr key={idx}>
                    {colonne.map((col) => (
                      <td
                        key={col.key}
                        className={col.mono ? 'bop-modale-cerca__cell-mono' : undefined}
                      >
                        {record[col.key] ?? '—'}
                      </td>
                    ))}
                    <td>
                      <button className="bop-btn-primary" onClick={() => onSeleziona(record)}>
                        Seleziona
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="bop-modale-cerca__actions">
          <button className="bop-btn-secondary" onClick={onChiudi}>
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}
